import type { CreateCoupleSchema, UpdateCoupleSchema } from '@/api/couples/couple.schema';
import type { Couple, Event } from 'generated/prisma/browser';
import { createCrudHooks } from './create-crud-hooks';

export const {
  keys: coupleKeys,
  useDetail: useCouple,
  useList: useCouples,
  useCreate: useCreateCouple,
  useUpdate: useUpdateCouple,
  useDelete: useDeleteCouple,
} = createCrudHooks<Couple & { event?: Event }, CreateCoupleSchema, UpdateCoupleSchema>(
  'couples',
);
